import messages from '../locales/pt_PT.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'pt-PT',
};
export default lang;
